import { AnyAction } from 'redux';
import { AccountApplicationCategoryView } from 'src/models';

import { OnboardStep } from '../models/app.models';

import { createAction, Type } from './utils';

export const doSetLastMfaCodeSentAt = (value: Date | null): AnyAction =>
  createAction(Type.LAST_MFA_CODE_SENT_AT, value);

export const doAddRedirectToOffer = (offerId: string): AnyAction => createAction(Type.ADD_REDIRECT_TO_OFFER, offerId);

export const doRemoveRedirectToOffer = (): AnyAction => createAction(Type.REMOVE_REDIRECT_TO_OFFER);

export const doAddRedirectToOfferOrder = (offerId: string): AnyAction =>
  createAction(Type.ADD_REDIRECT_TO_OFFER_ORDER, offerId);

export const doRemoveRedirectToOfferOrder = (): AnyAction => createAction(Type.REMOVE_REDIRECT_TO_OFFER_ORDER);

export const doAddRedirectToEmailConfirm = (payload: { confirm: string; updateId: number }): AnyAction =>
  createAction(Type.APP_REDIRECT_TO_EMAIL_CONFIRM_ADD, payload);

export const doRemoveRedirectToEmailConfirm = (): AnyAction => createAction(Type.APP_REDIRECT_TO_EMAIL_CONFIRM_REMOVE);

export const updateOnboardStep = (payload: OnboardStep): AnyAction => createAction(Type.UPDATE_ONBOARD_STEP, payload);

export const doAddOfferInvestReferrer = (payload: { id: string; name: string; logoUrl?: string }): AnyAction =>
  createAction(Type.ADD_OFFER_INVEST_REFERRER, payload);

export const doRemoveOfferInvestReferrer = (): AnyAction => createAction(Type.REMOVE_OFFER_INVEST_REFERRER);

export const doSetAccountApplicationCategoryViewList = (list: AccountApplicationCategoryView[]): AnyAction =>
  createAction(Type.SET_ACCOUNT_APPLICATION_CATEGORY_VIEW_LIST, list);

export const doAddRedirectToSummary = (): AnyAction => createAction(Type.ADD_REDIRECT_TO_SUMMARY);

export const doRemoveRedirectToSummary = (): AnyAction => createAction(Type.REMOVE_REDIRECT_TO_SUMMARY);

export const doAddNewAccountType = (): AnyAction => createAction(Type.ADD_NEW_ACCOUNT_TYPE);

export const doAddRedirectToCompleteAccountAfterSubmit = (): AnyAction =>
  createAction(Type.ADD_REDIRECT_TO_COMPLETE_ACCOUNT_AFTER_SUBMIT);

export const doRemoveRedirectToCompleteAccountAfterSubmit = (): AnyAction =>
  createAction(Type.REMOVE_REDIRECT_TO_COMPLETE_ACCOUNT_AFTER_SUBMIT);

export const doAddRedirectToLinkAccount = (): AnyAction => createAction(Type.ADD_REDIRECT_TO_LINK_ACCOUNT);

export const doRemoveRedirectToLinkAccount = (): AnyAction => createAction(Type.REMOVE_REDIRECT_TO_LINK_ACCOUNT);
